/* eslint-disable prefer-const */
import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeEvery } from 'redux-saga/effects';
import { ISystemConfigData, ISystemMonitoringData } from 'types/models/system-config';
import { formatPath } from 'utils';
import { apiGet, apiPost } from 'utils/api';
import SystemConfigPaths from '../models/paths';
import { fetchSystemConfig, fetchSystemConfigSuccess, fetchSystemMlog, updateSystemConfig, fetchSystemMlogSuccess, updateMlogConfig } from './slice';
import { closeAppBackdrop, notify, showAppBackdrop } from 'features/app/store/slice';
import { IApiResponse } from 'types/api';

export const apiFetchSystemConfig = () => {
  return apiGet<ISystemConfigData>(formatPath(SystemConfigPaths.get_system_config));
};

function* handleFetchDataSystemConfig(action: PayloadAction<string>) {
  try {
    yield put(showAppBackdrop());
    const response: IApiResponse<any> = yield call(apiFetchSystemConfig);
    if (response.data) {
      yield put(fetchSystemConfigSuccess(response.data));
      yield put(closeAppBackdrop());
    }
  } catch (e) {
    yield put(closeAppBackdrop());
  }
}

// llm_Mlog
export const apiFetchSystemMlogConfig = () => {
  return apiGet<ISystemMonitoringData>(formatPath(SystemConfigPaths.get_system_mlog_config));
}

function* handleFetchDataMolgSystemConfig(action: PayloadAction<string>) {
  try {
    yield put(showAppBackdrop());
    const response: IApiResponse<any> = yield call(apiFetchSystemMlogConfig);
    if (response.data) {
      yield put(fetchSystemMlogSuccess(response.data))
      yield put(closeAppBackdrop());
    }

  } catch (e) {
    yield put(closeAppBackdrop());
  }
}

export const apiUpdateSystemConfig = (query: Partial<ISystemConfigData>) => {
  return apiPost<ISystemConfigData>(formatPath(SystemConfigPaths.update_system_config),
    query
  )
}

function* handleUpdateSystemConfig(action: PayloadAction<ISystemConfigData>) {
  try {
    yield put(showAppBackdrop());
    const response: IApiResponse<any> = yield call(apiUpdateSystemConfig, action.payload);
    if (response.data) {
      yield put(fetchSystemConfigSuccess(response.data));
      yield put(
        notify("Update general llm success", { options: { variant: 'success' } })
      );
      yield put(closeAppBackdrop());
    } else {
      yield put(
        notify("Update general llm fail", { options: { variant: 'error' } })
      );
      yield put(closeAppBackdrop());
    }
  } catch (e) {
    yield put(
      notify("Update general llm fail", { options: { variant: 'error' } })
    );
    yield put(closeAppBackdrop());
  }
}

export const apiUpdateMlogSystemConfig = (query: Partial<ISystemMonitoringData>) => {
  return apiPost<ISystemMonitoringData>(formatPath(SystemConfigPaths.update_system_mlog_config),
    query
  )
}

function* handleUpdateMlogSystemConfig(action: PayloadAction<ISystemMonitoringData>) {
  try {
    yield put(showAppBackdrop());
    const response: IApiResponse<any> = yield call(apiUpdateMlogSystemConfig, action.payload);
    if (response.data) {
      yield put(fetchSystemConfigSuccess(response.data));
      yield put(
        notify("Update monitoring log llm success", { options: { variant: 'success' } })
      );
      yield put(closeAppBackdrop());
    } else {
      yield put(
        notify("Update monitoring log llm fail", { options: { variant: 'error' } })
      );
      yield put(closeAppBackdrop());
    }
  } catch (e) {
    yield put(
      notify("Update monitoring log llm fail", { options: { variant: 'error' } })
    );
    yield put(closeAppBackdrop());
  }
}

export default function* SystemConfigSaga() {
  yield takeEvery(fetchSystemConfig.type, handleFetchDataSystemConfig);
  yield takeEvery(updateSystemConfig.type, handleUpdateSystemConfig);
  yield takeEvery(fetchSystemMlog.type, handleFetchDataMolgSystemConfig);
  yield takeEvery(updateMlogConfig.type, handleUpdateMlogSystemConfig)
}
